import PropTypes from 'prop-types'
import { withStyles } from '@aura/components/styles'
import { useTranslation } from 'react-i18next'
import Grid from '@aura/components/grid'
import Box from '@aura/components/box'
import Typography from '@aura/components/typography'
import Button from '@aura/components/button'
import { useAuraThemeSwitcher } from '@aura/components/themes/context.js'
import SUPPORTED_THEMES from '../../constants/theme'
import styles from './styles'


const TIMEOUT_ILLUSTRATIONS = {
    [SUPPORTED_THEMES.DARK]: '/img/linkexp_dark.svg',
    [SUPPORTED_THEMES.LIGHT]: '/img/linkexp.svg'
}

const Component = ({
    classes,
    errorMessage,
    errorTitle,
    onResend
}) => {

    const { t: translate } = useTranslation()
    
    const title = errorTitle || translate('errorPage.linkExpiredTitle')
    const verbiage = errorMessage ? translate('oktaApiResponse.' + `${errorMessage}`) : translate('errorPage.linkExpiredMessage')
    
    // Show button for unauthorizedRecoveryToken or when no specific errorMessage is provided (expired link scenario)
    const showReturnButton = errorMessage === 'unauthorizedRecoveryToken' || !errorMessage
    const { theme } = useAuraThemeSwitcher()
    const paletteMode = theme?.palette?.mode
    const linkExpIllustration = TIMEOUT_ILLUSTRATIONS[paletteMode] || TIMEOUT_ILLUSTRATIONS[SUPPORTED_THEMES.LIGHT]

    return (
        <Grid container className={classes.gridContainerCentre}>
            <Grid className={classes.registrationRoot} item md={7} sm={8} xs={12}>
                <Box className={classes.header}>
                    <img className={classes.illustrationImage} src={linkExpIllustration} alt={title} />
                    <Box className={classes.copyWrapper}>
                        <Typography className={classes.title}>{title}</Typography>
                        <Typography className={classes.verbiage}>{verbiage}</Typography>
                        {showReturnButton && onResend && (
                            <Button
                                className={classes.returnButton}
                                onClick={onResend}
                                variant='contained'
                            >
                                {translate('errorPage.returnToLogin')}
                            </Button>
                        )}
                    </Box>
                </Box>
            </Grid>
        </Grid>
    )
    

}

Component.displayName = 'OktaRegistrationWizard.ErrorPage'

Component.propTypes = {
    classes: PropTypes.shape({
        heading: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        registrationRoot: PropTypes.string.isRequired,
        root: PropTypes.string.isRequired,
        verbiage: PropTypes.string.isRequired
    }),
    contactSupportMessage: PropTypes.bool,
    errorMessage: PropTypes.string,
    errorTitle: PropTypes.string,
    onResend: PropTypes.func
}
export default withStyles(Component, styles)
